import { ShaderSourceResource } from './ShaderSourceResource';

export class ShaderSource {
  constructor(
    public vertex: ShaderSourceResource,
    public fragment: ShaderSourceResource
  ) {}
}
